import axios from 'axios'
import {BASE_URL} from '@util/constant'
import { getAction } from './helper'
import { isExpired, decodeToken } from 'react-jwt'
import { CONTEXT_PATH } from '@util/constant'

let refreshing = false
let requestQueue = []
let netErrCnt = 0

axios.defaults.baseURL = BASE_URL
axios.defaults.withCredentials = false
axios.defaults.params = {}

const rfrAxiosInstance = axios.create({
  baseURL: BASE_URL,
})

rfrAxiosInstance.interceptors.response.use(
  (response) => {
    // Handle the successful token refresh response here
    // Update your token state with the new access token if needed
    return response
  },
  (error) => {
    // Handle errors during token refresh here
    return Promise.reject(error)
  }
)


const deviceNetWorkErrorMessage = '단말의 네트워크 커넥션이 없습니다. WI-FI/통신망 연결 후 다시 시도 하세요.'
const checkNetwork = async() => {
  return true
}


const refreshAccessToken = async () => {
  console.log('refreshAccessToken...')
  const url = '/public/refresh'
  const oldDeviceId = localStorage.getItem('deviceId')
  const oldRefreshToken = localStorage.getItem('refreshToken')

  if(!oldRefreshToken) {
    console.log('refreshToken not exists')
    return
  }
  if(!oldDeviceId) {
    console.log('deviceId not exists')
    return
  }
  const expired = isExpired(oldRefreshToken)
  if(expired) {
    return
  }


  // localStorage.removeItem('accessToken')
  // localStorage.removeItem('refreshToken')
  // localStorage.removeItem('deviceId')
  //
  const body = {
    refreshToken: oldRefreshToken,
    deviceId: oldDeviceId,
  }

  const resp = await rfrAxiosInstance.post(url, body)
  if(resp.data.repCode !== 'ack') {
    console.log('refresh failed', resp.data.repMessage)
    return
  }

  const repMessage = JSON.parse(resp.data.repMessage)
  const accessToken = repMessage.accessToken
  localStorage.setItem('accessToken', accessToken )

  const refreshToken = repMessage.refreshToken
  localStorage.setItem('refreshToken', refreshToken)

  const deviceId = repMessage.deviceId
  localStorage.setItem('deviceId', deviceId)

  console.log('refreshAccessToken successful')
  return accessToken
}


export default class WebService {
  static async post_not_use(action, data) {
    let response = await axios.post(action, data)
    return response.data
  }

  /*
  static async post(action, params) {
    const response = await axios.post(action, null, {
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      params: params
    })
    return response.data
  }
  */

  static async post(action, data, params={}) {
    const response = await axios.post(action, data, {params:params})
    return response.data
  }


  static async put(action, data, params={}) {
    let response = await axios.put(action, data, {params: params})
    return response.data
  }

  static async get(action, params={}) {
    const netOK = await checkNetwork()
    if(netOK) {
      let response = await axios.get(action, {params: params})
      return response.data
    }
    else {
      const result = {}
      result.resultCode = '-1'
      result.resultMessage = deviceNetWorkErrorMessage
      return result
    }
  }

  static async delete(url, params={}) {
    let action = url
    if(Object.keys(params).length > 0) {
      action = getAction(url, params)
    }
    let response = await axios.delete(action)
    return response.data
  }
  static async patch(action, data) {
    let response = await axios.patch(action, data)
    return response.data
  }
}

axios.interceptors.request.use(
  async config => {
    config.baseURL = BASE_URL
    // const token = await localStorage.getItem('token')
    const accessToken = localStorage.getItem('accessToken')

    config.headers['Authorization'] = accessToken ? `Bearer ${accessToken}` : ''
    // console.log('config=>', config)
    return config
  },
  error => {
    console.log('axios error while intercepting....')
    // Do something with request error
    return Promise.reject(error)
  }
)

const errorResult = {
  data:{
    repCode: 'cnak',
    repMessage: '서버와 통신 중 에러가 발생했습니다.',
  },
}

axios.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // if(!response.data?.repCode) {
    //   return Promise.resolve(errorResult)
    // }
    // return response;

    netErrCnt = 0
    if(response.data.repCode === 'reject') {
      window.location.href = '/logout'
      return response
    }
    else {
      return response
    }

  },
  async error => {
    console.log('=== error happen 2 ===')
    console.log(error)
    console.log('status=>', error.response?.status)
    console.log('====================')

    const originalRequest = error.config
    if(error.code === 'ERR_NETWORK') {
      netErrCnt = netErrCnt + 1
      console.log('netErrCnt=>', netErrCnt)
      if (netErrCnt > 5) {
        window.location.href = '/logout'
        return Promise.resolve(errorResult)
      }
      else {
        return axios(originalRequest)
      }
    }
    else if (error.code === 'ECONNABORTED' && error.message?.includes('timeout')) {
      errorResult.repMessage = '서버와의 통신시간이 초과되었습니다.'
      return Promise.resolve(errorResult)
    }
    else if (error.response?.status === 400) {
      errorResult.repMessage = '서버에 잘못된 요청을 보냈습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 401) {
      if(!refreshing) {
        refreshing = true
        try {
          const newAccessToken = await refreshAccessToken()
          if(!newAccessToken) {
            console.log('newAccessToken failed error ')
            window.location.href = '/logout'
            return Promise.resolve(errorResult)
          }
          else {
            axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`

            // Retry the original request
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
            return axios(originalRequest)
          }
        }
        catch(error) {
          window.location.href = '/logout'
          return Promise.resolve(errorResult)
        }
        finally {
          refreshing = false
        }
      }
      else {
        return axios(originalRequest)
      }
    }
    else if(error.response?.status === 403) {
      errorResult.repMessage = '인증이 만료되었습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 404) {
      errorResult.repMessage = '서버 URL을 찾을 수 없습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 405) {
      errorResult.repMessage = '요청한 메소드를 수행할 수 없습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 406) {
      errorResult.repMessage = '리소스에 접근할 수 없습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 421) {
      errorResult.repMessage = '리다이렉션 오류입니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 422) {
      errorResult.repMessage = '요청 문법에 오류가 있습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 423) {
      errorResult.repMessage = '리소스에 접근하는 것이 잠겨있습니다.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 500) {
      errorResult.repMessage = '서버 프로그램 오류 입니다. 관리자에게 문의하세요.'
      return Promise.resolve(errorResult)
    }
    else if(error.response?.status === 503 || error.response?.status === 504) {
      console.log('service on repair')
      const message = error?.response?.data?.message || ''
      if (window.location.pathname.startsWith('/repair')) {
        return Promise.resolve(errorResult)
      }

      window.location.href = `/repair/${encodeURIComponent(message)}`
      return Promise.resolve(errorResult)
    }
    else {
      return Promise.resolve(errorResult)
    }

    /*


    if (error.response && error.response.status === 401) {
      if(!refreshing) {
        refreshing = true
        try {
          const newAccessToken = await refreshAccessToken()
          if(!newAccessToken) {
            console.log('newAccessToken failed error ')
            window.location.href = `/logout`
            return Promise.resolve(errorResult)
          }
          else {
            axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

            // Retry the original request
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
            return axios(originalRequest);
          }
        }
        catch(error) {
          window.location.href = `/logout`
          return Promise.resolve(errorResult)
        }
        finally {
          refreshing = false
        }
      }
      else {
        return axios(originalRequest);
      }
    }
    else {
      console.log('other request is refreshing token....')
      return Promise.resolve(errorResult)
    }
    */
  }
)
